import { Wrapper, CloseButtonWrapper } from '@/components/Layout/Menu/HeaderV2/components/NewAiHeaderButton/NewAiHeaderButton.styles';
import styled, { css } from 'styled-components';

export const OnboardingHandlerWrapper = styled.div`
  ${({
    theme, $centered, $isInitialStep, $isLoading,
  }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    display: flex;
    flex-direction: column;
    justify-content: ${$centered ? 'center' : 'flex-start'};
    min-height: 100%;

    ${$isLoading ? css`
      height: 100%;
    ` : css`
      height: ${$isInitialStep ? 'auto' : '100%'};
    `}
  `}
`;

export const LogoRow = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v2.colors.white.primary};
    border-bottom: 1px solid ${theme.v2.colors.brand.primaryLowLight};
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    height: 82px;
    min-height: 82px;
    padding: 0 32px;
    position: relative;
    width: 100%;
    z-index: 10;
    > :first-child {
      width: 200px;
    }

    > :last-child {
      width: 200px;
      display: flex;
      justify-content: flex-end;
      position: relative;
      z-index: 15;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 112px;
      padding: 0;
      flex-direction: column;
      margin-top: 14px;
      padding: 0 0 51px 0;
      position: relative;

      > :first-child {
        width: auto;
        position: absolute;
        left: 16px;
        top: 14px;
      }

      > :last-child {
        width: auto;
        position: absolute;
        right: 16px;
        top: 14px;
      }
    }
  `}
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0 auto;
  width: 100%;
  height: 100%;
`;

export const IconLoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

export const NewAiWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    ${Wrapper} {
      width: 50%;
    }
   ${CloseButtonWrapper} {
      left: 50%;
      right: auto;
      top: 121px;
      transform: translateX(-50%);
      @media (max-width: 776px) {
        top: 182px;
      }
      @media (max-width: ${theme.v2.breakpoints.sm}) {
        left: 94%;
        top: 371px;
      }
    }   

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 24px 0px;
      margin: 0;
      ${Wrapper} {
        width: 90%;
      }
    }
  `}
`;

export const ConversationBox = styled.div`
  ${({ theme, $focused }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    
    > div {
      width: 100%;
    }
    ${Wrapper} {
      position: absolute;
      top: 15px;
      z-index: ${$focused ? 20 : 5};
      @media (max-width: ${theme.v2.breakpoints.md}) {
        top: 49px;
      }
    }
  `}
`;

export const Logo = styled.div`
  @media (max-width: ${({ theme }) => theme.v2.breakpoints.md}) {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    top: 24px;
    z-index: 1;
    padding: 0 16px;
    transition: opacity 0.1s ease;
    opacity: ${({ $show }) => ($show ? 1 : 0)};
    pointer-events: ${({ $show }) => ($show ? 'auto' : 'none')};
    visibility: ${({ $show }) => ($show ? 'visible' : 'hidden')};
  }
`;

export const BackWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  position: relative;
  z-index: 15;
`;
